module.exports = __webpack_public_path__ + "img/tws6.04756af8.png";